<template>
    <div class="referral">
        <v-container v-if="refWithdrawEnable === 0" style="background: #effafc;">
            <div class="container-tabs">
                <h1 style="position: relative;height: 50px;top: 50%;left: 40%;">Giới thiệu đang được bảo trì</h1>
            </div>
        </v-container>
        <v-container v-else fluid grid-list-lg>
            <h3 class="primary--text pl-5">Mời bạn bè</h3>
            <v-row class="px-5 share-link">
                <v-col>
                    <v-card flat color="white">
                        <v-card-text cols="12">
                            <span>Mời bạn bè để nhận ngay tiền hoa hồng vào đầu tháng khi họ tạo job.</span><br>
                            <span>Chia sẻ link giới thiệu ngay:</span>
                        </v-card-text>
                        <v-card-actions>
                            <v-row class="pb-0">
                                <v-col cols="8" class="pb-0">
                                    <v-text-field
                                            single-line
                                            :value="link_share"
                                            outlined
                                            disable
                                            id="ref-code"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="3" class="pb-0">
                                    <v-btn max-width="120px" class="mt-1" large color="primary" @click="copyRefCode">Chép</v-btn>
                                </v-col>
                            </v-row>
                        </v-card-actions>
                        <v-card-text cols="12" class="py-0">
                            <span>Mã giới thiệu:</span>
                            <span class="caption"><i>(Mã này dùng để bạn bè nhập khi đăng kí tài khoản mới)</i></span>
                        </v-card-text>
                        <v-card-actions>
                            <v-row class="pb-0">
                                <v-col cols="8" class="pb-0 py-0">
                                    <v-text-field
                                            single-line
                                            :value="share_code"
                                            outlined
                                            disable
                                            id="share-code"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="3" class="pb-0 py-0">
                                    <v-btn max-width="120px" class="mt-1" large color="primary" @click="copyShareCode">Chép</v-btn>
                                </v-col>
                            </v-row>
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-row>

            <!--videoRef-->
            <div class="pl-5" v-if="videoId">
                <div class="v-sheet theme--light explain">
                    <a href="#videoRef">
                        <span class="blue_text label-highlight">Video hướng dẫn giới thiệu</span>
                    </a>
                </div>
            </div>

            <h3 class="primary--text pl-5">Banner giới thiệu</h3>
            <v-row class="px-5 share-link">
                <v-col>
                    <table class="width-100p collapsible" width="100%" border="0" cellspacing="2"
                           cellpadding="2">
                        <tbody>
                        <tr class="row">
                            <th scope="row" class="col-xl-2 col-sm-2">
                                <label for="banner_size" class="bold">Chọn size:</label>
                            </th>
                            <td class="banner_name col-xl-10 col-sm-10">
                                <select class="texture width-250" v-model="selected">
                                    <option v-for="(banner) in banners"
                                        v-bind:key="banner.value"
                                        v-bind:value="{
                                            value: banner.value,
                                            name: banner.name,
                                            width: banner.width,
                                            height: banner.height,
                                            src: banner.src,
                                            title: banner.title,
                                            alt: banner.name,
                                            site_url: banner.site_url
                                        }">
                                        {{ banner.name }}
                                    </option>
                                </select>
                            </td>
                        </tr>
                        <tr class="row">
                            <th class="col-xl-2 col-sm-2">&nbsp;</th>
                            <td class="banner_img col-xl-10 col-sm-10">
                                <img class="width-400-max"
                                    :width="selected.width"
                                    :height="selected.height"
                                    :src="selected.src"
                                    :title="selected.title"
                                    :alt="selected.alt"><br>
                            </td>
                        </tr>
                        <tr class="row">
                            <th scope="row" class="col-xl-2 col-sm-2">
                                <label for="referral_banner_src_link" class="bold">Banner SRC:</label>
                            </th>
                            <td id="referral_banner_src_link_form" class="color-wrapper l4l padd-10 col-xl-10 col-sm-10">
                                <div class="wrap-all texture padd-10" id="referral_banner_src_link"
                                     name="referral_banner_src_link">
                                    {{ selected.src }}
                                </div>
                            </td>
                        </tr>
                        <tr class="row">
                            <th scope="row" class="col-xl-2 col-sm-2">
                                <label for="referral_banner_html_link" class="bold">Banner HTML:</label>
                            </th>
                            <td id="referral_banner_html_link_form" class="color-wrapper l4l padd-10 col-xl-10 col-sm-10">
                                <div class="wrap-all texture padd-10" id="referral_banner_html_link"
                                     name="referral_banner_html_link">
                                    &lt;a href="{{ link_share }}" title="{{ selected.title }}"&gt;&lt;img width="{{ selected.width }}" height="{{ selected.height }}" title="{{ selected.title }}" src="{{ selected.src }}" alt="{{ selected.title }}" /&gt;&lt;/a&gt;
                                </div>
                            </td>
                        </tr>
                        <tr class="row">
                            <th scope="row" class="col-xl-2 col-sm-2">
                                <label for="referral_banner_forum_1_link" class="bold">Forums URL (1):</label>
                            </th>
                            <td id="referral_banner_forum_1_link_form" class="color-wrapper l4l padd-10 col-xl-10 col-sm-10">
                                <div class="wrap-all texture padd-10" id="referral_banner_forum_1_link"
                                     name="referral_banner_forum_1_link">
                                    [URL={{ link_share }}][IMG]{{ selected.src }}[/IMG][/URL]
                                </div>
                            </td>
                        </tr>
                        <tr class="row">
                            <th scope="row" class="col-xl-2 col-sm-2">
                                <label for="referral_banner_forum_2_link" class="bold">Forums URL (2):</label>
                            </th>
                            <td id="referral_banner_forum_2_link_form" class="color-wrapper l4l padd-10 col-xl-10 col-sm-10">
                                <div class="wrap-all texture padd-10" id="referral_banner_forum_2_link"
                                     name="referral_banner_forum_2_link">
                                    [URL={{ link_share }}][IMG={{ selected.src }}][/URL]
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>

                </v-col>
            </v-row>

            <h3 class="primary--text pl-5">Tổng các khách mời</h3>
            <v-row class="px-5">
                <v-col>
                    <v-card class="number-invited" flat>
                        <v-list-item three-line>
                            <v-list-item-content>
                                <v-list-item-title class="subtitle-1 white--text mb-1">
                                    <span>Số khách đã mời</span><br>
                                    <span class="font-weight-bold">{{ userInfo.count_precenter}}</span>
                                </v-list-item-title>
                            </v-list-item-content>

                            <v-list-item-icon>
                                <v-icon color="white">mdi-account-multiple</v-icon>
                            </v-list-item-icon>
                        </v-list-item>
                    </v-card>
                </v-col>
                <v-col>
                    <v-card class="reward" flat>
                        <v-list-item three-line>
                            <v-list-item-content>
                                <v-list-item-title class="subtitle-1 white--text mb-1">
                                    <span>Số tiền nhận được</span><br>
                                    <span class="font-weight-bold">{{ userInfo.gem_recieve }} GEM</span>
                                </v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-icon>
                                <v-icon color="white">mdi-cash-usd</v-icon>
                            </v-list-item-icon>
                        </v-list-item>
                    </v-card>
                </v-col>
            </v-row>
            <h3 class="primary--text pl-5 mt-3">Danh sách người đã mời</h3>
            <v-row class="px-5">
                <v-col>
                    <v-card class="mx-auto" v-if="listPresenter.length > 0">
                        <v-list two-line subheader>
                            <v-list-item
                                v-for="presenter in listPresenter"
                                :key="presenter.id"
                            >
                                <v-list-item-content>
                                    <v-list-item-title>{{ presenter.user.username }}</v-list-item-title>
                                    <!--<v-list-item-subtitle>Nhận ref <span class="font-weight-bold primary&#45;&#45;text">{{ percent_presenter }}%</span>-->
                                    <!--</v-list-item-subtitle>-->
                                </v-list-item-content>

                                <v-list-item-action>
                                    <span>Thu nhập</span><br/>
                                    <span class="font-weight-bold primary--text">{{ presenter.gem }} GEM</span>
                                </v-list-item-action>
                            </v-list-item>
                        </v-list>
                    </v-card>
                    <h3 v-if="listPresenter.length <= 0" class="text-center body-1">Hiện chưa có bạn mời</h3>
                </v-col>
            </v-row>

            <br>
            <!--video youtube-->
            <v-row align-center row v-if="videoId" id="videoRef">
                <v-flex md8>
                    <div class="col-sm-12 mb-n3">
                        <h3 class="text-color">HƯỚNG DẪN SỬ DỤNG</h3>
                    </div>
                    <div class="col-sm-12 mb-n3">
                        <youtube :video-id="videoId" ref="youtube"
                                 @buffering="playing"
                                 @paused="paused"
                                 @ended="paused"
                                 @playing="playing"
                                 width="100%" height="650px">
                        </youtube>
                    </div>
                </v-flex>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import {
    COMMON_SET_SNACK,
    AUTH_USER,
    REFERRAL_LIST_BANNER,
    REFERRAL_LIST_PRESENTER,
    GET_PERCENT_PRESENTER,
    CONFIG_PAGE,
    CONFIG_OTHER_PAGE
} from "~/store/actions.type";

export default {

    data() {
        return {
            refWithdrawEnable: 1,
            userInfo: {},
            listPresenter: {},
            link_share: '',
            share_code: '',
            selected: {},
            banners: [],
            site_url: window.location.protocol + '//' + window.location.host,
            videoId: '',
            videoStatus: true,
        }
    },
    created() {
        this.initialize();
    },
    computed: {
        percent_presenter() {
            return this.$store.getters.percentPresenter;
        }
    },
    methods: {
        async initialize() {
            await this.$store.dispatch(CONFIG_PAGE).then((data) => {
                let refWithdrawStatus = data.filter(o => o.key == 'key_cp_ref_withdraw');
                this.refWithdrawEnable = parseInt(refWithdrawStatus[0]['status']);
            });

            await this.$store.dispatch(AUTH_USER).then(({data}) => {
                this.userInfo = data;
                this.link_share = this.site_url + '/register?ref=' + this.userInfo.username;
                this.share_code = this.userInfo.username;
            }).catch(() => {
                this.$store.dispatch(COMMON_SET_SNACK, {
                    message: 'Đã có lỗi xảy ra, vui lòng thử lại sau !',
                    type: "error"
                });
            });

            await this.$store.dispatch(GET_PERCENT_PRESENTER);

            await this.$store.dispatch(REFERRAL_LIST_BANNER).then(({data}) => {
                if (data.length !== 0) {
                    let dataArr = Object.values(data);

                    this.selected = {
                        value: dataArr[0].banner_size_value,
                        name: dataArr[0].banner_size_name,
                        width: dataArr[0].banner_width,
                        height: dataArr[0].banner_height,
                        src: dataArr[0].banner_src,
                        title: dataArr[0].banner_title,
                        alt: dataArr[0].banner_size_name,
                        site_url: this.site_url
                    };

                    for (let i = 0; i < dataArr.length; i++) {
                        this.banners.push({
                            value: dataArr[i].banner_size_value,
                            name: dataArr[i].banner_size_name,
                            width: dataArr[i].banner_width,
                            height: dataArr[i].banner_height,
                            src: dataArr[i].banner_src,
                            title: dataArr[i].banner_title,
                            alt: dataArr[i].banner_size_name,
                            site_url: this.site_url
                        });
                    }
                }

            }).catch(() => {
                this.$store.dispatch(COMMON_SET_SNACK, {
                    message: 'Đã có lỗi xảy ra, vui lòng thử lại sau !',
                    type: "error"
                });
            });

            await this.$store.dispatch(REFERRAL_LIST_PRESENTER).then(({data}) => {
                this.listPresenter = data;
            }).catch(() => {
                this.$store.dispatch(COMMON_SET_SNACK, {
                    message: 'Đã có lỗi xảy ra, vui lòng thử lại sau !',
                    type: "error"
                });
            });

            this.data = await this.$store.dispatch(CONFIG_OTHER_PAGE);
            for (let i = 0; i < this.data.length; i++) {
                if (this.data[i].type === 'referral') {
                    if (this.data[i].video) {
                        let videoId = this.youtube_parser(this.data[i].video);
                        if (videoId) {
                            this.videoId = videoId;
                        }
                    }
                }
            }
        },
        copyRefCode() {
            let testingCodeToCopy = document.querySelector('#ref-code');
            testingCodeToCopy.setAttribute('type', 'text');
            testingCodeToCopy.select();
            try {
                document.execCommand('copy');
                this.$store.dispatch(COMMON_SET_SNACK, {
                    message: 'Đã copy link mời bạn bè thành công !',
                    type: "success"
                });
            } catch (err) {
                console.log('Oops, unable to copy');
            }
        },

        copyShareCode() {
            let testingCodeToCopy = document.querySelector('#share-code');
            testingCodeToCopy.setAttribute('type', 'text');
            testingCodeToCopy.select();
            try {
                document.execCommand('copy');
                this.$store.dispatch(COMMON_SET_SNACK, {
                    message: 'Đã copy mã giới thiệu thành công !',
                    type: "success"
                });
            } catch (err) {
                console.log('Oops, unable to copy');
            }
        },

        playing() {
            this.videoStatus = false;
        },
        paused() {
            this.videoStatus = true;
        },
        youtube_parser(url) {
            let regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
            let match = url.match(regExp);
            return (match && match[7].length == 11) ? match[7] : false;
        }
    }
};
</script>
<style scoped lang="scss">
    .referral {
        .number-invited {
            background: linear-gradient(51.19deg, #0084F8 9.02%, #58C2F1 90.81%);
        }
        .reward {
            background: linear-gradient(69.69deg, #00F8BC 9.02%, #58C2F1 90.81%);
        }
        .v-icon{
            font-size: 55px;
        }
        .v-list-item__action {
            line-height: 10px !important;
            margin-top: 20px;
        }
        .share-link {
            position: relative;
            .social-sharing {
                position: absolute;
                top: 10px;
                right: 10px;
                cursor: pointer;
            }
        }
    }

    @media (max-width: 759px) {
        body table.collapsible td, table.collapsible th {
            display: block !important;
            text-align: center !important;
        }
    }
    select.texture {
        font-weight: 400;
        font-family: Arial,Helvetica,sans-serif;
        background-color: #e3e3e3;
        height: auto;
        background-image: url("data:image/svg+xml;utf8,<svg fill='black' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>");
        background-repeat: no-repeat;
        background-position-x: 100%;
        background-position-y: 5px;
        width: 250px;
        border: 1px solid #b8b8b8;
        box-shadow: inset 0 1px 1px rgba(0,0,0,.075);
        border-radius: 4px;
        padding: 6px 3px;
    }
    .texture {
        font-weight: 400;
        font-family: Arial,Helvetica,sans-serif;
        background-color: #e3e3e3;
        height: auto;
    }

    .color-wrapper.l4l {
        background: #f9bf45;
        background: linear-gradient(to bottom left,#f9bf45,#f69259);
    }
    .color-wrapper {
        overflow: hidden;
        background-size: cover;
        background-position: center;
        -webkit-box-shadow: inset 0 0 1px rgb(32,32,32,1), 1px 1px 1px #7c7c7c;
        box-shadow: inset 0 0 1px rgb(32,32,32,1), 1px 1px 1px #7c7c7c;
    }
    * .padd-10 {
        padding: 10px;
    }
    .wrap-all {
        word-break: break-all!important;
    }
    tr.row{
        margin-right: 12px !important;
        margin-bottom: 1px;
    }
    tr.row td.color-wrapper{
        background: #4267b2 !important;
    }
    tr.row th{
        text-align: left;
    }
    td.banner_name,
    td.banner_img{
        margin-left: -10px;
    }

</style>
